function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import ProGallery from './proGallery/proGallery';
import { PRESETS } from './presets';
import basePropTypes from './proGallery/propTypes';
import LAYOUTS from '../../common/constants/layout';
import dimensionsHelper from '../helpers/dimensionsHelper';
import defaultStyles from '../../common/defaultStyles';

var BaseGallery =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(BaseGallery, _React$Component);

  function BaseGallery() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BaseGallery.prototype;

  _proto.render = function render() {
    var domId = this.props.domId || 'default-dom-id';

    var _this$props = this.props,
        styles = _this$props.styles,
        options = _this$props.options,
        styleParams = _this$props.styleParams,
        eventsListener = _this$props.eventsListener,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["styles", "options", "styleParams", "eventsListener"]);

    var _styles = _objectSpread({}, defaultStyles, {}, options, {}, styles, {}, styleParams);

    var _eventsListener = function _eventsListener() {
      return typeof eventsListener === 'function' && eventsListener.apply(void 0, arguments);
    };

    var galleryProps = _objectSpread({}, otherProps, {
      styles: _styles,
      eventsListener: _eventsListener,
      domId: domId
    });

    dimensionsHelper.updateParams({
      domId: galleryProps.domId,
      container: galleryProps.container,
      styles: galleryProps.styles
    });
    var _galleryProps$styles = galleryProps.styles,
        galleryType = _galleryProps$styles.galleryType,
        galleryLayout = _galleryProps$styles.galleryLayout;
    var GalleryComponent = ProGallery;

    if (galleryType === undefined || galleryLayout !== undefined) {
      switch (galleryLayout) {
        case LAYOUTS.MASONRY:
          GalleryComponent = PRESETS.MasonryGallery;
          break;

        case LAYOUTS.GRID:
          GalleryComponent = PRESETS.GridGallery;
          break;

        case LAYOUTS.THUMBNAIL:
          GalleryComponent = PRESETS.ThumbnailGallery;
          break;

        case LAYOUTS.SLIDER:
          GalleryComponent = PRESETS.SliderGallery;
          break;

        case LAYOUTS.SLIDESHOW:
          GalleryComponent = PRESETS.SlideshowGallery;
          break;

        case LAYOUTS.PANORAMA:
          GalleryComponent = PRESETS.PanoramaGallery;
          break;

        case LAYOUTS.COLUMN:
          GalleryComponent = PRESETS.ColumnGallery;
          break;

        case LAYOUTS.MAGIC:
          GalleryComponent = PRESETS.MagicGallery;
          break;

        case LAYOUTS.FULLSIZE:
          GalleryComponent = PRESETS.FullsizeGallery;
          break;

        case LAYOUTS.BRICKS:
          GalleryComponent = PRESETS.BricksGallery;
          break;

        case LAYOUTS.MIX:
          GalleryComponent = PRESETS.MixGallery;
          break;

        case LAYOUTS.ALTERNATE:
          GalleryComponent = PRESETS.AlternateGallery;
          break;

        case LAYOUTS.EMPTY:
          GalleryComponent = PRESETS.EmptyGallery;
          break;

        case LAYOUTS.COLLAGE:
        default:
          GalleryComponent = PRESETS.CollageGallery;
      }
    }

    return React.createElement(GalleryComponent, galleryProps);
  };

  return BaseGallery;
}(React.Component);

export { BaseGallery as default };